import APIV5 from '~/models/api';
import templateModalWfHistory from '~/components/wf/modal/modal-wf-history.html';
import ModalWfHistoryController from '~/components/wf/modal/modal-wf-history.controller';
import WorkflowService from '~/scripts/services/workflow.service';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

/* globals Knitiv */

export default class WfAffectListController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$filter,
		$location,
		$rootScope,
		$sce,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Notification,
	) {
		this.$injector = $injector;
		this.$filter = $filter;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$sce = $sce;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Notification = Notification;

		/** @type {any[] | undefined} */
		this.data = undefined;

		/** @type {any} */
		this.defaultOptions = {
			eligible:      true,
			list:          'ALL',
			node:          undefined,
			required:      true,
			showAddButton: true,
		};

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {any[]} */
		this.group = [];

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {any[]} */
		this.modelActions = [];

		/** @type {any} */
		this.options = {};

		/** @type {any[]} */
		this.selected = [];

		/** @type {boolean} */
		this.showAddWorkflow = true;

		/** @type {any} */
		this.affectList = {
			open: [],
			close: [],
		};

		this.workflowService = new WorkflowService(this.$injector);
	}

	async openModalHistory(job = null) {
		try {
			await this.$uibModal.open({
				template:     templateModalWfHistory,
				controller:   ModalWfHistoryController,
				controllerAs: '$ctrl',
				resolve:      {
					jobs: () => (job ? [job] : this.selected),
				},
				size:         'full-with-footer',
			}).result;
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	async list() {
		if (this.kid !== null) {
			const affectList = await this.workflowService.nodeAffectList(this.kid);
			for (const id of ['open', 'close']) {
				// @ts-ignore
				this.affectList[id] = affectList && id in affectList && Array.isArray(affectList[id])
					// @ts-ignore
					? affectList[id].map(affect => new WorkflowAffect(this.$injector, affect))
					: [];
			}
			this.$timeout(() => this.$scope.$apply());
		}
	}

	/**
	 * @param {any} job
	 * @returns {any}
	 */
	openJob(job) {
		if (this.kform?.options.modal) {
			this.kform.options.modal.dismiss();
		}
		return this.$location.path(`/workflow/${job.kid}`);
	}

	/**
	 * @param {any} job
	 */
	async subscriptionSet(job) {
		const jobs = job ? [job] : this.selected;
		for (const job2 of jobs) {
			await APIV5.instance.wfSubscriptionSet({ objnum: job2.kid });
			this.Notification.info({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('workflow.successful-subscription'),
			});
		}
	}

	$onInit() {
		this.options = {
			...this.defaultOptions,
			...this.options,
			node: this.kid,
		}

		if (!Array.isArray(this.modelActions)) {
			this.modelActions = [];
		}

		if (this.modelActions.length > 0) {
			this.showAddWorkflow = true;
		}

		(async () => this.list())();
		this.$scope.$on('Form.submitted', () => this.list());

		this.group.push({
			...this.options,
			id:           'open',
			panelClass:   'panel-info',
			icon:         'fa-play-circle',
			title:        this.$translate.instant('workflow.title-open'),
			showAdd:      this.showAddWorkflow && !this.disabled,
			checkBox:     true,
			subscription: true,
			history:      true,
			openWf:       true,
		}, {
			...this.options,
			id:           'close',
			icon:         'fa-stop-circle',
			panelClass:   'panel-success',
			title:        this.$translate.instant('workflow.title-close'),
			showAdd:      false,
			checkBox:     false,
			subscription: false,
			history:      true,
			openWf:       false,
		});
	}
}
